<template>
  <layout name="BaseLayout">
    <div>
      <v-data-table ref="dataTable" dense :headers="tableHeaders" :items="items" :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc" class="elevation-1" :loading="loading" :loading-text="loadingText" :footer-props="{
          itemsPerPageOptions: rowsPerPage,
          itemsPerPageAllText: allTextForPerPage,
          itemsPerPageText: itemsPerPageText,
        }" :options="options" :search="search" :custom-filter="customFilter" :no-results-text="filtersNoResultText">
        <!-- formatear el texto de la paginacion -->
        <template v-slot:footer.page-text="props">
          {{ props.pageStart }} - {{ props.pageStop }} de
          {{ props.itemsLength }}
        </template>

        <!-- cabecera (toolbar + filtros) antes del header de la tabla -->
        <template v-slot:top>
          <v-toolbar text color="white">
            <v-toolbar-title>Notas</v-toolbar-title>

            <v-divider class="mx-4" inset vertical></v-divider>

            <v-btn :loading="loading" :disabled="loading" @click="refreshItems" text color="primary">
              Actualizar
              <v-icon right dark>mdi-refresh</v-icon>
            </v-btn>
          </v-toolbar>

          <!-- Filtros -->
          <v-container fluid>
            <v-row class="pl-3 pr-3 pt-1">
              <!-- Filtrar Buscador -->
              <v-col class="pt-0 pb-0" cols="4">
                <v-text-field class="pt-0 pb-0" v-model="search" prepend-icon="mdi-magnify" type="text" label="Buscar"
                  hide-details clearable></v-text-field>
              </v-col>

              <!-- Filtrar en idioma -->
              <v-col class="pt-0 pb-0" cols="4">
                <v-select class="pt-0 pb-0" :items="idiomas" item-text="nombre" item-value="nombre" label="Idiomas"
                  v-model="searchIdioma" clearable @change="cargarNiveles" :no-data-text="selectNoDataText"></v-select>
              </v-col>

              <!-- Filtrar en nivel -->
              <v-col class="pt-0 pb-0" cols="4">
                <v-select class="pt-0 pb-0" :items="niveles" label="Nivel" v-model="searchNivel" clearable
                  item-text="descripcion" item-value="descripcion" :no-data-text="selectNoDataText"
                  :disabled="!searchIdioma"></v-select>
              </v-col>
            </v-row>

            <v-row class="pl-3 pr-3">
              <!-- Filtrar en dias -->
              <v-col class="pt-0 pb-0" cols="4">
                <v-select class="pt-0 pb-0" :items="dias" label="Días" v-model="searchDias" clearable
                  item-text="descripcion" item-value="descripcionCorta" :no-data-text="selectNoDataText"></v-select>
              </v-col>

              <!-- Filtrar en horarios -->
              <v-col class="pt-0 pb-0" cols="4">
                <v-select class="pt-0 pb-0" :items="horarios" label="Horarios" v-model="searchHorarios" clearable
                  item-text="descripcion" item-value="descripcion" :no-data-text="selectNoDataText"></v-select>
              </v-col>

              <v-col class="pt-0 pb-0" cols="4">
                <v-autocomplete class="pt-0 pb-0" :items="aulas" v-model="selectedAula" label="Aulas"
                  :search-input.sync="searchAulas" clearable item-text="numero" item-value="numero"
                  :loading="aulasLoading" hide-no-data hide-selected allow-overflow
                  @click:clear="clearAulas"></v-autocomplete>
              </v-col>
            </v-row>

            <!-- Boton borrado de filtros-->
            <v-row v-if="showDeleteFilters" class="pa-0">
              <v-col cols="12" justify="center" align="center">
                <v-btn text dark color="primary" @click="borrarFiltros">
                  Borrar Filtros
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
          <!-- ./Filtros-->
        </template>

        <!-- combo de edicion para la columna notaJunio -->
        <template v-if="userCanEdit || userCanEditLlodio" v-slot:item.notaJunio.descripcion="props">
          <v-edit-dialog :return-value.sync="props.item.notaJunio" @save="saveNotaJunio(props.item)"
            @cancel="cancelNotaJunio" @open="openNotaJunio(props.item, props.item.notaJunio)" @close="closeNotaJunio"
            large persistent :cancel-text="editDialogCancelText" :save-text="editDialogSaveText">
            <div>{{ props.item.notaJunio.descripcion }}</div>

            <template v-slot:input>
              <div class="mt-4 title">Actulizar Nota Junio</div>
            </template>

            <template v-slot:input>
              <v-select :items="notas" label="Nota" :value="props.item.notaJunio" item-text="descripcion"
                :no-data-text="selectNoDataText" return-object @change="saveNotaJunioTemp"></v-select>
            </template>
          </v-edit-dialog>
        </template>

        <!-- combo de edicion para la columna notaSeptiembre -->
        <template v-if="userCanEdit || userCanEditLlodio" v-slot:item.notaSeptiembre.descripcion="props">
          <v-edit-dialog :return-value.sync="props.item.notaSeptiembre" @save="saveNotaSeptiembre(props.item)"
            @cancel="cancelNotaSeptiembre" @open="openNotaSeptiembre(props.item, props.item.notaSeptiembre)"
            @close="closeNotaSeptiembre" large persistent :cancel-text="editDialogCancelText"
            :save-text="editDialogSaveText">
            <div>{{ props.item.notaSeptiembre.descripcion }}</div>

            <template v-slot:input>
              <div class="mt-4 title">Actulizar Nota Junio</div>
            </template>

            <template v-slot:input>
              <v-select :items="notas" label="Nota" :value="props.item.notaSeptiembre" item-text="descripcion"
                :no-data-text="selectNoDataText" return-object @change="saveNotaSeptiembreTemp"></v-select>
            </template>
          </v-edit-dialog>
        </template>

        <!-- textarea de edicion para la column de Observaciones -->
        <template v-if="userCanEdit || userCanEditLlodio" v-slot:item.observaciones="props">
          <v-edit-dialog :return-value.sync="props.item.observaciones" @save="saveObservaciones(props.item)"
            @cancel="cancelObservaciones" @open="openObservaciones(props.item, props.item.observaciones)"
            @close="closeObservaciones" large persistent :cancel-text="editDialogCancelText"
            :save-text="editDialogSaveText">
            <div>{{ props.item.observaciones | truncate(15, "...") }}</div>

            <template v-slot:input>
              <div class="mt-4 title">Actulizar Observaciones</div>
            </template>

            <template v-slot:input>
              <v-textarea class="w-450" label="Observaciones" :value="props.item.observaciones"
                @change="saveObservacionesTemp"></v-textarea>
            </template>
          </v-edit-dialog>
        </template>
        <!-- Dialog par ver el contenido de Observaciones para los usuarios que no tiene permisos de edicion -->
        <template v-else v-slot:item.observaciones="{ item }">
          <v-dialog v-if="item.observaciones != null && item.observaciones.length > 0" scrollable max-width="600px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn small color="primary" icon dark v-bind="attrs" v-on="on">
                <v-icon small>
                  mdi-information-outline
                </v-icon>
              </v-btn>
            </template>

            <v-card>
              <v-card-title>Observaciones</v-card-title>

              <v-divider></v-divider>

              <v-card-text style="height: 300px;">
                <p class="pt-4">{{ item.observaciones }}</p>
              </v-card-text>
            </v-card>
          </v-dialog>
        </template>

        <!-- Se muestra con resultado vacio -->
        <template v-slot:no-data>
          {{ filtersNoResultText }}
        </template>
      </v-data-table>
    </div>
  </layout>
</template>

<script>
import Layout from "@/components/layouts/Layout.vue";
import { mapGetters, mapMutations } from "vuex";
import { getIdiomas } from "@/api/idiomas.api";
import { getAllNiveles } from "@/api/niveles.api";
import { getByCurso, update } from "@/api/matriculas.api";
import { getAllNotas } from "@/api/notas.api";
import { getAllDias } from "@/api/dias.api";
import { getAllHorarios } from "@/api/horarios.api";
import { findByNumeroAula } from "@/api/aulas.api";
import _ from "lodash";

export default {
  name: "MatriculasNotas",

  components: {
    Layout,
  },

  data: () => ({
    items: [],
    headers: [],
    idiomas: [],
    niveles: [],
    notas: [],
    dias: [],
    horarios: [],
    aulas: [],
    sortBy: "alumno.nombre",
    sortDesc: false,
    rowsPerPage: [25, 50, 75, 100, -1],
    options: {
      itemsPerPage: 25,
    },
    loading: false,
    aulasLoading: false,

    // columnas editables
    notaJunioEditedIndex: -1,
    notaJunioEditedItem: null,
    notaJunioTemp: null,
    notaSeptiembreEditedIndex: -1,
    notaSeptiembreEditedItem: null,
    notaSeptiembreTemp: null,
    observacionesEditedIndex: -1,
    observacionesEditedItem: null,
    observacionesTemp: null,

    // valores de los filtros
    search: "",
    searchIdioma: "",
    searchNivel: "",
    searchDias: "",
    searchHorarios: "",
    searchAulas: null,
    selectedAula: "",

    // textos varios
    filtersNoResultText: "No se han encontrado resultados",
    loadingText: "Cargando ...",
    itemsPerPageText: "Filas por página:",
    allTextForPerPage: "Todas",
    selectNoDataText: "No hay valores",
    editDialogCancelText: "Cancelar",
    editDialogSaveText: "Guardar",

    // listados de roles para determinar listado de notas
    authorizedToSeeAllStudents: ["ROLE_SUPER_ADMIN"],
  }),

  watch: {
    cursoActual() {
      this.items = [];
      this.initialize();
    },

    async searchAulas(value) {
      // value is empty
      if (_.isEmpty(value)) {
        this.clearAulas();
        return;
      }

      // Aulas have already been loaded
      if (this.aulas.length > 0) return;

      // Aulas have already been requested
      if (this.aulasLoading) {
        return;
      }

      this.aulasLoading = true;

      await findByNumeroAula(value)
        .then((response) => {
          this.aulas = response.data;
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => (this.aulasLoading = false));
    },
  },

  created() {
    this.initialize();
  },

  computed: {
    ...mapGetters("App", {
      cursoActual: "GET_CURSO_ACTUAL",
    }),

    ...mapGetters("Auth", {
      userCanEdit: "userCanEdit",
    }),

    ...mapGetters("Auth", {
      userCanEditLlodio: "userCanEditLlodio",
    }),

    ...mapGetters("Auth", {
      userRoles: "authRoles",
    }),

    tableHeaders() {
      return this.headers;
    },

    showDeleteFilters() {
      return (
        this.search ||
        this.searchIdioma ||
        this.searchNivel ||
        this.searchDias ||
        this.searchHorarios ||
        this.searchAulas
      );
    },
  },

  methods: {
    ...mapMutations("Snack", {
      setSnack: "SET_SNACK_OPTIONS",
    }),

    /**
     * inicializa todos los valores necesarios del componente
     */
    async initialize() {
      this.loading = true;

      if (this.cursoActual) {
        /**
         * Config table headers
         */
        this.headers = [
          //{ text: 'Id matricula', align: 'start', value: 'id'},
          { text: "Apellidos, Nombre", align: "start", value: "alumno.nombre" },
          {
            text: "Idioma",
            align: "start",
            value: "nivel.idioma.nombre",
            filter: (value) => {
              return this.filtrarIdioma(value);
            },
          },
          {
            text: "Nivel",
            align: "start",
            value: "nivel.descripcion",
            filter: (value) => {
              return this.filtrarNivel(value);
            },
          },
          {
            text: "Días",
            align: "start",
            value: "grupo.dia.descripcionCorta",
            filter: (value) => {
              return this.filtrarDias(value);
            },
          },
          {
            text: "Horario",
            align: "start",
            value: "grupo.horario.descripcion",
            filter: (value) => {
              return this.filtrarHorarios(value);
            },
          },
          {
            text: "Aula",
            align: "start",
            value: "grupo.aula.numero",
            filter: (value) => {
              return this.filtrarAulas(value);
            },
          },
          {
            text: "Nota Junio",
            align: "start",
            value: "notaJunio.descripcion",
          },
          {
            text: "Nota Septiembre",
            align: "start",
            value: "notaSeptiembre.descripcion",
          },
          {
            text: "Observaciones",
            align: (this.userCanEdit || this.userCanEditLlodio) ? "start" : "center",
            value: "observaciones",
            sortable: false,
          },
        ];

        await getIdiomas().then((response) => (this.idiomas = response.data));

        await getAllNiveles().then(
          (response) => (this.allNiveles = response.data)
        );

        await getAllNotas().then((response) => (this.notas = response.data));

        await getAllDias().then((response) => (this.dias = response.data));

        await getAllHorarios().then(
          (response) => (this.horarios = response.data)
        );

        await getByCurso(this.cursoActual.id).then(
          // (response) => response.data.forEach((el) => console.log(el))
          (response) => {
            if (!this.authorizedToSeeAllStudents.includes(this.userRoles[0])) {
              const allowedLocation = this.userRoles[0]
                .split("ROLE_SUPER_ADMIN_")[1]
                .toLowerCase();

              this.items = this.parseItems(
                response.data.filter(
                  (el) =>
                    el.grupo.localizacion.nombre.toLowerCase() ===
                    allowedLocation
                )
              );

              return;
            }

            this.items = this.parseItems(response.data);
          }
        );
      }

      this.loading = false;
    },

    async refreshItems() {
      this.loading = true;
      this.items = [];
      await getByCurso(this.cursoActual.id).then(
        (response) => (this.items = this.items = this.parseItems(response.data))
      );
      this.loading = false;
    },

    parseItems(matriculas) {
      let items = [];
      matriculas.forEach((matricula) => {
        matricula.notaJunio =
          matricula.notaJunio == null ? {} : matricula.notaJunio;
        matricula.notaSeptiembre =
          matricula.notaSeptiembre == null ? {} : matricula.notaSeptiembre;
        items.push(matricula);
      });
      return items;
    },

    /**
     * Buscador (custom filter)
     *
     * Filtra por:
     *   - alumno:
     *     - Nombre y apellidos
     *     - dni
     */
    customFilter(value, search, item) {
      let inAlumnoNombre = RegExp(search, "i").test(item.alumno.nombre);
      let inAlumnoDni = RegExp(search, "i").test(item.alumno.dni);

      return inAlumnoNombre || inAlumnoDni;
    },

    /**
     * Filtro Idiomas
     */
    filtrarIdioma(value) {
      // no se ha seleccionado idioma se retornan todos
      if (!this.searchIdioma) {
        return true;
      }

      // se ha seleccionado idioma quitamos todos los valores nulos, vacios y no definidos
      if (typeof value == "undefined" || value == null || value == "") {
        return false;
      }

      // retornamos coincidencias
      return value.toLowerCase() == this.searchIdioma.toLowerCase();
    },

    /**
     * Filtro Nivel
     */
    filtrarNivel(value) {
      if (!this.searchNivel) {
        return true;
      }

      if (typeof value == "undefined" || value == null || value == "") {
        return false;
      }

      return value.toLowerCase() == this.searchNivel.toLowerCase();
    },

    /**
     * devuelve los niveles de un idioma
     */

    filtrarNivelesPorIdioma(idioma) {
      return this.allNiveles.filter((nivel) => {
        return nivel.idioma.id == idioma.id;
      });
    },

    /**
     * Filtro Dias
     */
    filtrarDias(value) {
      if (!this.searchDias) {
        return true;
      }

      if (_.isNil(value) || _.isEmpty(value)) {
        return false;
      }

      return value.toLowerCase() == this.searchDias.toLowerCase();
    },

    /**
     * Filtro Horarios
     */
    filtrarHorarios(value) {
      if (!this.searchHorarios) {
        return true;
      }

      if (_.isNil(value) || _.isEmpty(value)) {
        return false;
      }

      return value.toLowerCase() == this.searchHorarios.toLowerCase();
    },

    /**
     * Filtro Aulas
     */
    filtrarAulas(value) {
      if (!this.selectedAula) {
        return true;
      }

      if (_.isNil(value) || _.isEmpty(value)) {
        return false;
      }

      return value.toLowerCase() == this.selectedAula.toLowerCase();
    },

    clearAulas() {
      this.aulas = [];
    },

    /**
     * Resetear los filtros seleccionados
     */
    borrarFiltros() {
      this.search = "";
      this.searchIdioma = "";
      this.searchNivel = "";
      this.niveles = [];
      this.searchDias = "";
      this.searchHorarios = "";
      this.searchAulas = "";
    },

    /**
     * valores desponibles en el filtro de nivel teniendo en cuenta el idioma
     */
    cargarNiveles() {
      this.niveles = [];
      this.searchNivel = "";

      // no esta definido o está vacio.
      if (!this.searchIdioma || typeof this.searchIdioma === "undefined") {
        return;
      }

      // buscar el idioma seleccionado
      let idiomaSeleccionado = this.idiomas.find((idioma) => {
        return idioma.nombre.toLowerCase() == this.searchIdioma.toLowerCase();
      });

      // no ha sido posible encontrar el idioma seleccionado
      if (typeof idiomaSeleccionado === "undefined") {
        return;
      }

      // devolver los niveles del idioma seleccionado
      this.niveles = Object.assign(
        [],
        this.filtrarNivelesPorIdioma(idiomaSeleccionado)
      );
      return;
    },

    /**
     * Metodos para la edicion de la columna notaJunio
     */
    saveNotaJunio(item) {
      // comprobar que tenemos identificado el elemento a guardar
      if (this.notaJunioEditedIndex > -1 && this.notaJunioTemp != null) {
        // se ha actualizado guardamos ...
        if (
          typeof this.notaJunioTemp.id != "undefined" ||
          this.notaJunioEditedItem.notaJunio.id != this.notaJunioTemp.id
        ) {
          // api put con la nueva nota
          item.notaJunio = Object.assign(this.notaJunioTemp);

          update(item)
            .then((response) => {
              if (response.status == 200) {
                this.items[this.notaJunioEditedIndex].notaJunio = Object.assign(
                  {},
                  response.data.notaJunio
                );
                this.setSnack({
                  active: true,
                  timeout: 1500,
                  color: this.$getStringFor("snack", "successColor"),
                  text: this.$getStringFor("snack", "successText"),
                });
              } else {
                this.setSnack({
                  active: true,
                  timeout: 1500,
                  color: this.$getStringFor("snack", "errorColor"),
                  text: this.$getStringFor("snack", "errorText"),
                });
              }
              this.resetNotaJunioEditedValues();
            })
            .catch((error) => {
              console.error(error);
            });
        }
      } else {
        this.setSnack({
          active: true,
          timeout: 1500,
          color: this.$getStringFor("snack", "errorColor"),
          text: this.$getStringFor("snack", "errorText"),
        });
        this.resetNotaJunioEditedValues();
      }
    },
    saveNotaJunioTemp(value) {
      if (typeof value === "undefined") {
        this.notaJunioTemp = {};
      } else {
        this.notaJunioTemp = Object.assign(value);
      }
    },
    cancelNotaJunio() {
      this.setSnack({
        active: true,
        timeout: 1500,
        color: this.$getStringFor("snack", "cancelColor"),
        text: this.$getStringFor("snack", "cancelText"),
      });
      this.resetNotaJunioEditedValues();
    },
    openNotaJunio(item) {
      this.notaJunioEditedIndex = this.items.indexOf(item);
      this.notaJunioEditedItem = Object.assign({}, item);
    },
    closeNotaJunio() {
      // hacer algo ...
    },
    resetNotaJunioEditedValues() {
      this.notaJunioEditedIndex = -1;
      this.notaJunioEditedItem = null;
      this.notaJunioTemp = null;
    },

    /**
     * Metodos para la edicion de la columna notaSeptiembre
     */
    saveNotaSeptiembre(item) {
      // comprobar que tenemos identificado el elemento a guardar
      if (
        this.notaSeptiembreEditedIndex > -1 &&
        this.notaSeptiembreTemp != null
      ) {
        // se ha actualizado guardamos ...
        if (
          typeof this.notaSeptiembreTemp.id != "undefined" ||
          this.notaSeptiembreEditedItem.notaSeptiembre.id !=
          this.notaSeptiembreTemp.id
        ) {
          // api put con la nueva nota
          item.notaSeptiembre = Object.assign(this.notaSeptiembreTemp);

          update(item)
            .then((response) => {
              if (response.status == 200) {
                this.items[
                  this.notaSeptiembreEditedIndex
                ].notaSeptiembre = Object.assign(
                  {},
                  response.data.notaSeptiembre
                );
                this.setSnack({
                  active: true,
                  timeout: 1500,
                  color: this.$getStringFor("snack", "successColor"),
                  text: this.$getStringFor("snack", "successText"),
                });
              } else {
                this.setSnack({
                  active: true,
                  timeout: 1500,
                  color: this.$getStringFor("snack", "errorColor"),
                  text: this.$getStringFor("snack", "errorText"),
                });
              }
              this.resetNotaSeptiembreEditedValues();
            })
            .catch((error) => {
              console.error(error);
            });
        }
      } else {
        this.setSnack({
          active: true,
          timeout: 1500,
          color: this.$getStringFor("snack", "errorColor"),
          text: this.$getStringFor("snack", "errorText"),
        });
        this.resetNotaSeptiembreEditedValues();
      }
    },
    saveNotaSeptiembreTemp(value) {
      if (typeof value === "undefined") {
        this.notaSeptiembreTemp = {};
      } else {
        this.notaSeptiembreTemp = Object.assign(value);
      }
    },
    cancelNotaSeptiembre() {
      this.setSnack({
        active: true,
        timeout: 1500,
        color: this.$getStringFor("snack", "cancelColor"),
        text: this.$getStringFor("snack", "cancelText"),
      });
      this.resetNotaSeptiembreEditedValues();
    },
    openNotaSeptiembre(item) {
      this.notaSeptiembreEditedIndex = this.items.indexOf(item);
      this.notaSeptiembreEditedItem = Object.assign({}, item);
    },
    closeNotaSeptiembre() {
      // hacer algo ...
    },
    resetNotaSeptiembreEditedValues() {
      this.notaSeptiembreEditedIndex = -1;
      this.notaSeptiembreEditedItem = null;
      this.notaSeptiembreTemp = null;
    },

    /**
     * Metodos para la edicion de la columna Observaciones
     */
    saveObservaciones(item) {
      // comprobar que tenemos identificado el elemento a guardar
      if (
        this.observacionesEditedIndex > -1 &&
        this.observacionesTemp != null
      ) {
        // se ha actualizado guardamos ...
        if (
          this.observacionesEditedItem.observaciones != this.observacionesTemp
        ) {
          // api put con la nueva nota
          item.observaciones = Object.assign(this.observacionesTemp);

          update(item)
            .then((response) => {
              if (response.status == 200) {
                this.items[this.observacionesEditedIndex].observaciones =
                  response.data.observaciones;
                this.setSnack({
                  active: true,
                  timeout: 1500,
                  color: this.$getStringFor("snack", "successColor"),
                  text: this.$getStringFor("snack", "successText"),
                });
              } else {
                this.setSnack({
                  active: true,
                  timeout: 1500,
                  color: this.$getStringFor("snack", "errorColor"),
                  text: this.$getStringFor("snack", "errorText"),
                });
              }
              this.resetObservacionesEditedValues();
            })
            .catch((error) => {
              console.error(error);
            });
        }
      } else {
        this.setSnack({
          active: true,
          timeout: 1500,
          color: this.$getStringFor("snack", "errorColor"),
          text: this.$getStringFor("snack", "errorText"),
        });
        this.resetObservacionesEditedValues();
      }
    },
    saveObservacionesTemp(value) {
      if (value === null) {
        this.observacionesTemp = "";
      } else {
        this.observacionesTemp = value;
      }
    },
    cancelObservaciones() {
      this.setSnack({
        active: true,
        timeout: 1500,
        color: this.$getStringFor("snack", "cancelColor"),
        text: this.$getStringFor("snack", "cancelText"),
      });
      this.resetObservacionesEditedValues();
    },
    openObservaciones(item) {
      this.observacionesEditedIndex = this.items.indexOf(item);
      this.observacionesEditedItem = Object.assign({}, item);
      this.saveObservacionesTemp(item.observaciones);
    },
    closeObservaciones() {
      // hacer algo
    },
    resetObservacionesEditedValues() {
      this.observacionesEditedIndex = -1;
      this.observacionesEditedItem = null;
      this.observacionesTemp = null;
    },
  },
};
</script>

<style lang="scss">
.w-450 {
  width: 450px !important;
}
</style>
